module.exports = __webpack_public_path__ + "static/media/sector1.7cde3076.svg";